import { render, staticRenderFns } from "./AcademyEdit.vue?vue&type=template&id=7e88454c&"
import script from "./AcademyEdit.vue?vue&type=script&lang=js&"
export * from "./AcademyEdit.vue?vue&type=script&lang=js&"
import style0 from "./AcademyEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports